module.exports = __webpack_public_path__ + "img/contents_title_sub06.c654177a.png";